<template>
  <div>
    <el-row :span="24" :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="12">
        <el-date-picker
          v-model="date"
          :clearable='false'
          format="d MMM yy"
          value-format="MM-dd-yyyy"
          type="date"
          placeholder="As At">
        </el-date-picker>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <el-table
      :data="data"
      stripe
      max-height="650"
      size="small"
      :row-class-name="tableRowClassName"
      :empty-text="$t('general_noData')"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="Date">
      </el-table-column>
      <el-table-column
        width="120"
        prop="id"
        label="ID"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="id"
        label="Entry Type"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="description"
        label="Description">
      </el-table-column>
      <el-table-column
        width="120"
        prop="createdBy"
        label="Created By">
      </el-table-column>
      <el-table-column
        width="120"
        prop="grossAmt"
        label="Gross Amt">
      </el-table-column>
      <el-table-column
        width="120"
        prop="taxAmt"
        label="Tax Amt">
      </el-table-column>
      <el-table-column
        width="120"
        prop="taxCode"
        label="Tax Code"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="sourceDoc"
        label="Source Doc."
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="vendorStatus"
        label="Status"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="report"
        label="Report"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="reported"
        label="Reported"
        align="center">
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment');
  export default {
    name: 'Credits',
    data() {
      return {
        date: moment().format("MM-DD-YYYY"),
        data: [],
      }
    },
    methods: {
      loadList() {
        // let loader = this.$loading.show();
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .get(`/api/v1/account/taxAccountsResult?companyId=${this.$route.query.companyId}&endDate=${this.date}`)
        //   .then(response => {
        //     this.outputTax = response.data.data.outputTax
        //     this.outputTaxSubAccounts = response.data.data.outputTaxSubAccounts
        //     this.inputTax = response.data.data.inputTax
        //     this.inputTaxSubAccounts = response.data.data.inputTaxSubAccounts
        //     this.creditableVatWithheld = response.data.data.creditableVatWithheld
        //     this.creditableVatWithheldSubAccounts = response.data.data.creditableVatWithheldSubAccounts
        //     this.getSalesTaxPayableBalance = response.data.data.getSalesTaxPayableBalance
        //     loader.hide()
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //     loader.hide()
        //   });
      },
      tableRowClassName({row, rowIndex}) {
        return 'cursor-pointer';
      },
    },
    watch:{
      'date': function (val) {
        this.loadList()
      }
    },
  }
</script>

<style lang="scss" scoped>
.data-hide {
  /deep/.el-table__body-wrapper {
    display: none;
  }
}
/deep/.el-table .bg-row {
  background: #f2f4f7;
}
</style>